import { type FC } from 'react'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { experimentsCompeteraTrackCompeteraEvent } from '../../../experiments/competera-experiment/experimentsCompeteraTrackCompeteraEvent'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA } from '../../../experiments/eventTracking'
import { useGlobalConfigContext } from '../../../global-config'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemTitle: FC = () => {
  const { algoliaRecord, query = '' } = useProductSearchResultItemContext()

  const { experiments } = useExperimentsContext()
  const globalConfig = useGlobalConfigContext()

  const {
    __position: position,
    __queryID: queryID = '',
    productName,
  } = algoliaRecord

  return (
    // Switching to `NextLink` investigation under https://jira.shop-apotheke.com/browse/WSAWA-7078
    <a
      className="flex flex-1 self-stretch text-ellipsis text-s font-medium after:absolute after:inset-0 hover:underline"
      data-qa-id="serp-result-item-title"
      href={algoliaProxyRecordAccessorGetDeeplink({
        params: {
          eventName: 'click on product list item',
          position,
          query,
          queryID,
        },
        record: algoliaRecord,
      })}
      onClick={(): void => {
        experimentsCompeteraTrackCompeteraEvent(
          experiments,
          globalConfig,
          EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA,
        )
      }}
    >
      {productName}
    </a>
  )
}
